import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"
import DataListModal from "../../DataModals/DataListModal"
import * as Basic from "../../../Modules/BasicFields"

export default function CharacterSheet( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const modalOpen = props.modalOpen
    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)
    const [ font, setFont ] = useState(null)
    const [ list, setList ] = useState(null)

    const [ showModal, setShowModal ] = useState(false)

    const requiredData = [
        hashtag,
        hashtagRate,
        font,
        list
    ]

    const cfgName = "echo_chambers_character_sheet_cfg"


    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setFont( cfg.font || {})
        setHashtag( cfg.hashtag || "")
        setHashtagRate( cfg.hashtag_rate || "one_per_user")
        setList( cfg.list || [] )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.font = font 
        data.hashtag = hashtag
        data.hashtag_rate = hashtagRate 
        data.list = list

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ font, hashtag, hashtagRate, list ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.ButtonInput name="Edit attribute list" onClick={e => setShowModal(true)}/>
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag} />
                <Basic.SelectInput name="Frequency per viewer" value={hashtagRate} setValue={setHashtagRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                   ]}
                /> 
            </SettingsGroup>
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            /> 
            <DataListModal modalTitle="Attribute list"
                           showModal={showModal}
                           setShowModal={setShowModal}
                           modalOpen={modalOpen}
                           list={list}
                           setList={setList}
            />


        </>
    )
}
